import { StoreDetailsModel } from "../@types/storeDetails.model";

export const $StorelocatorModuleName = "storelocator";
export interface LocalizedStoresSearchParams {
    limit?: number;
    sku?: string;
    filterEmptyStock: boolean;
    longitude?: number;
    latitude?: number;
    textualLocation?: string;
    storeId?: string;
    includeProductAvailability?: boolean;
    features?: string;
}

export type TStoreLocatorState = Array<StoreDetailsModel>;
